export default "__VITE_ASSET__64cdb203__"